import React from "react";

import "./Menubar.css";

const Menubar = (props) => {
  const { menubarState } = props;
  const mClass = menubarState ? "menubar menubar-" + menubarState : "menubar";
  return (
    <div className={mClass}>
      <ul className="menubar-list">
        <a href="/hirealawyer">
          <li className="menubar-list-item">Hire a Lawyer</li>
        </a>
        <a href="/asktheexpert">
          <li className="menubar-list-item">Ask the Expert</li>
        </a>
        <a href="/registeraslawyer">
          <li className="menubar-list-item">Register as Lawyer</li>
        </a>
        <a href="/login" className="login">
          <li className="menubar-list-item">Login</li>
        </a>
        <a href="/signup" className="signup">
          <li className="menubar-list-item">Sign Up</li>
        </a>
      </ul>
      <div className="menubar-connect"></div>
    </div>
  );
};

export default Menubar;
